import { fork, takeLatest } from 'redux-saga/effects';
import ActionConstants from '../constants';
import workerSaga from './workerSaga';
import { takeLatestUntilApiCancel } from './merchantListing';

// ------------------------------------
// Watchers
// ------------------------------------

function* disputeWatcher(): Generator<any, void, unknown> {
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_DISPUTE_LIST);
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_DISPUTE_DETAILS);
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_DISPUTE_ORDER_LIST_V3);
  yield fork(
    takeLatestUntilApiCancel,
    ActionConstants.GET_DISPUTE_ORDER_DETAILS_V3
  );
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_DISPUTE_DOCUMENT_CONFIG);
  yield takeLatest(ActionConstants.UPLOAD_CHARGEBACK_DOCUMENT, workerSaga);
  yield takeLatest(ActionConstants.REUPLOAD_CHARGEBACK_DOCUMENT, workerSaga);
  yield takeLatest(ActionConstants.GET_DISPUTES_FEATURE_FLAG, workerSaga);
}

export default disputeWatcher;
